import { IApplicationContext } from '../../../types/applicationContext';
import {
  fetchPublicOfferAccept,
  type TPublicOfferAcceptResponse,
} from '../../../repositories/dailyrent/v1/public-offer/accept';

export async function fetchAcceptPublicOffer(context: IApplicationContext) {
  const { httpApi, logger } = context;

  try {
    const response: TPublicOfferAcceptResponse = await fetchPublicOfferAccept({
      httpApi,
    });

    if (response.statusCode !== 200) {
      throw new Error(`Failed to accept public offer. Error: ${response.response.message}`);
    }

    return response as TPublicOfferAcceptResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
